import {createContext, type ReactNode, useContext} from 'react'

import type {SelectionContextValue} from '../codemirror/extensions/selection-context'

const SelectionContext = createContext<SelectionContextValue | null>(null)

export interface SelectionContextProviderProps {
  children: ReactNode
  value: SelectionContextValue
}

/**
 * Provider component that supplies markdown context state to child components
 */
export function SelectionContextProvider({children, value}: SelectionContextProviderProps) {
  return <SelectionContext value={value}>{children}</SelectionContext>
}

/**
 * Hook to access the markdown context. Must be used within a SelectionContextProvider.
 */
export function useSelectionContext(): SelectionContextValue {
  const context = useContext(SelectionContext)
  if (!context) {
    throw new Error('useSelectionContext must be used within a SelectionContextProvider')
  }
  return context
}

try{ SelectionContext.displayName ||= 'SelectionContext' } catch {}
try{ SelectionContextProvider.displayName ||= 'SelectionContextProvider' } catch {}